'use client';

import { type PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';

import Cookies from 'js-cookie';

type ThemeProviderParams = {
  isDarkTheme: boolean;
  handleThemeChange: VoidFunction;
};
const ThemeContext = createContext<ThemeProviderParams | undefined>(undefined);

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [isDarkTheme, setIsDarkTheme] = useState(
    Cookies.get('theme') === 'dark' ||
      (!Cookies.get('theme') && typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkTheme);
  }, [isDarkTheme]);

  const handleThemeChange = () => {
    const newTheme = isDarkTheme ? 'light' : 'dark';
    Cookies.set('theme', newTheme, { expires: 365 });
    setIsDarkTheme((prev) => !prev);
  };

  return (
    <ThemeContext.Provider
      value={{
        isDarkTheme,
        handleThemeChange
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('Please use this hook inside ThemeProvider!');
  }

  return context;
};
